import React from 'react';
import { Link } from 'react-router-dom';

const StreaksPrivacy = () => {
  return (
    <div className="legal-page">
      <div className="legal-page__header">
        <div className="container">
          <Link to="/" className="legal-page__back">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5" />
              <path d="M12 19l-7-7 7-7" />
            </svg>
            Back to Home
          </Link>
          <span className="section__tag">Legal</span>
          <h1 className="legal-page__title">Privacy Policy</h1>
          <p className="legal-page__subtitle">
            Streaks by Wolf Technologies Ltd
          </p>
          <p className="legal-page__date">Last updated: 15 April 2026</p>
        </div>
      </div>

      <div className="container">
        <div className="legal-page__content">

          <section className="legal-section">
            <h2>1. Introduction</h2>
            <p>
              Streaks ("we", "our", "the app") is a habit tracking application developed by
              Wolf Technologies Ltd. We take your privacy seriously. This policy explains what
              data we collect, how we use it, and your rights.
            </p>
          </section>

          <section className="legal-section">
            <h2>2. Data We Collect</h2>
            <ul>
              <li><strong>Account information</strong> — Email address (used for authentication and identification).</li>
              <li><strong>Habit data</strong> — Habit names, descriptions, and categories you create.</li>
              <li><strong>Check-in timestamps</strong> — Records of when you mark habits as complete.</li>
              <li><strong>Streak data</strong> — Current streaks, best streaks, and streak freeze usage.</li>
              <li><strong>Subscription status</strong> — Whether you are on the free or premium plan, and subscription expiry dates.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>3. Data We Do NOT Collect</h2>
            <ul>
              <li><strong>Location data</strong></li>
              <li><strong>Contacts</strong></li>
              <li><strong>Photos or media</strong></li>
              <li><strong>Health or fitness data</strong></li>
              <li><strong>Browsing history</strong> or activity outside the app</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>4. How We Use Your Data</h2>
            <ul>
              <li>To provide and operate the habit tracking service.</li>
              <li>To calculate streaks, momentum scores, and analytics.</li>
              <li>To manage your subscription and premium features.</li>
              <li>To sync data across your devices.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>5. Data Storage & Security</h2>
            <p>
              All data is stored in Amazon Web Services (AWS) in the eu-west-2 (London, UK) region.
              Data is encrypted at rest and in transit using industry-standard encryption (AES-256, TLS 1.2+).
            </p>
            <p>
              Authentication is managed by AWS Cognito with secure password hashing.
              We do not sell, rent, or share your personal data with third parties for marketing purposes.
            </p>
          </section>

          <section className="legal-section">
            <h2>6. Third-Party Services</h2>
            <ul>
              <li><strong>AWS Cognito</strong> — Authentication and user account management.</li>
              <li><strong>AWS DynamoDB</strong> — Secure storage of your habit and streak data.</li>
              <li><strong>Stripe</strong> — Payment processing for premium subscriptions (web only). We do not store credit card details.</li>
              <li><strong>Apple In-App Purchase</strong> — Payment processing for premium subscriptions (iOS only). Purchases are handled entirely by Apple.</li>
            </ul>
          </section>

          <section className="legal-section">
            <h2>7. Data Sharing</h2>
            <p>
              We do not sell or share your personal data with third parties. The only third parties
              that receive any data are payment processors (Stripe and Apple) strictly for the purpose
              of processing your subscription payments.
            </p>
          </section>

          <section className="legal-section">
            <h2>8. Data Retention & Deletion</h2>
            <p>
              Your data is retained as long as your account is active. If you wish to delete your
              account and all associated data, you can request deletion by contacting us. All data
              will be permanently deleted within 30 days of a deletion request.
            </p>
          </section>

          <section className="legal-section">
            <h2>9. Your Rights (GDPR)</h2>
            <p>
              If you are in the European Economic Area (EEA) or the United Kingdom, you have the
              following rights:
            </p>
            <ul>
              <li><strong>Access</strong> — Request a copy of your personal data.</li>
              <li><strong>Rectification</strong> — Correct inaccurate data.</li>
              <li><strong>Erasure</strong> — Request deletion of your data ("right to be forgotten").</li>
              <li><strong>Portability</strong> — Export your data in a standard format.</li>
              <li><strong>Restriction</strong> — Restrict processing of your data.</li>
              <li><strong>Objection</strong> — Object to processing of your data.</li>
            </ul>
            <p>
              Our legal basis for processing is your consent (account creation) and legitimate
              interest (providing the service).
            </p>
          </section>

          <section className="legal-section">
            <h2>10. Advertising</h2>
            <p>
              Streaks does not display advertisements. We do not share your data with advertising networks.
            </p>
          </section>

          <section className="legal-section">
            <h2>11. Changes to This Policy</h2>
            <p>
              We may update this policy from time to time. We will notify you of significant changes
              via the app or email.
            </p>
          </section>

          <section className="legal-section">
            <h2>12. Contact Us</h2>
            <p>
              If you have questions about this privacy policy or wish to exercise your data rights,
              please contact us:
            </p>
            <div className="legal-contact">
              <p><strong>Wolf Technologies Ltd</strong></p>
              <p>United Kingdom</p>
              <p>
                Email:{' '}
                <a href="mailto:support@wolftechnologies.co.uk">support@wolftechnologies.co.uk</a>
              </p>
            </div>
          </section>

        </div>
      </div>
    </div>
  );
};

export default StreaksPrivacy;
